import { GlobalCacheStore } from '@inter-ikea-kompis/utilities';
import FontFace from './FontFace.js';
/**
 * Class for inserting font-face styles to the head of the document.
 * All components extending the KompisElement class uses the FontLoader.
 */
export default class FontLoader {
    /**
     * Appends style element to head of document.
     *
     * @param theme Theme.
     * @param [cacheStore] Cache store.
     */
    static loadFont(theme, cacheStore = new GlobalCacheStore()) {
        if (cacheStore.getStore('fontLoader').get(theme.fontFace.family)) {
            return;
        }
        cacheStore.getStore('fontLoader').set(theme.fontFace.family, true);
        const styleElement = document.createElement('style');
        styleElement.innerHTML = `
            /* Added by @inter-ikea-kompis/themes/lib/utilities/FontLoader.js */
            ${FontFace.getFontFaces(theme)}
        `;
        document.head.appendChild(styleElement);
    }
}
//# sourceMappingURL=FontLoader.js.map